/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./PuffNotice.scss";

function PuffNotice({ ...restProps }) {
  return (
    // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
    <div {...restProps} className={cn("puff-notice scope-cb8cd9f3", restProps.className)}>
      <div className="puff-notice__bulb-icon-wrapper scope-cb8cd9f3">
        <UseSvg
          className="puff-notice__bulb-icon scope-cb8cd9f3"
          icon="bulb"
          data-testid="puff-notice-bulb-icon"
        />
      </div>
      <div className="puff-notice__notice-wrapper scope-cb8cd9f3">
        {" "}
        Elevate Your Designs with Puff: <br className="puff-notice__br scope-cb8cd9f3" />
        <a
          className="scope-cb8cd9f3"
          href="#image-design-tips"
          onClick={e => {
            e.stopPropagation();
          }}
          data-testid="puff-notice-a"
        >
          Tips to Get Started
        </a>
      </div>
    </div>
  );
}

export default PuffNotice;
